/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rosy_Mild_Finch_DrawInputs */

const en_rosy_mild_finch_draw = /** @type {(inputs: Rosy_Mild_Finch_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors`)
};

const de_rosy_mild_finch_draw = /** @type {(inputs: Rosy_Mild_Finch_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler-Log`)
};

/**
* | output |
* | --- |
* | "Errors" |
*
* @param {Rosy_Mild_Finch_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rosy_mild_finch_draw = /** @type {((inputs?: Rosy_Mild_Finch_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rosy_Mild_Finch_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rosy_mild_finch_draw(inputs)
	return de_rosy_mild_finch_draw(inputs)
});